<ng-template #redeCredenciada let-modal="modal">
  <div class="modal-header" style="background: linear-gradient(135deg, #37474f 0%, #37474f 100%); border: none">
    <h5 class="modal-title text-white">
      <i class="fa fa-building mr-2"></i>
      Rede Credenciada - {{ listaModal?.produto }}
    </h5>
    <button type="button" class="close text-white" (click)="fecharRede()">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body" style="background: #f8f9fc">
    <!-- Busca -->
    <div class="search-wrapper mb-4">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text bg-white border-right-0">
            <i class="fa fa-search text-primary"></i>
          </span>
        </div>
        <input
          type="text"
          [(ngModel)]="filtroRede"
          placeholder="Buscar hospital ou laboratório..."
          class="form-control border-left-0 pl-0"
          style="border-radius: 0 8px 8px 0" />
      </div>
    </div>

    <!-- Hospitais -->
    <div class="section-hospital mb-4">
      <div class="d-flex align-items-center mb-3">
        <div class="icon-circle bg-info mr-2">
          <i class="fa fa-hospital-o text-white"></i>
        </div>
        <h4 class="mb-0 font-weight-bold text-dark">Hospitais</h4>
        <span class="badge badge-info ml-2 px-2 round">{{ contarHospitais(listaModal) }}</span>
      </div>

      <div *ngIf="listaModal?.hospitalsInZone?.length > 0; else noHospitais">
        <div *ngFor="let city of listaModal.hospitalsInZone | filterZone: filtroRede; let i = index">
          <!-- Cidade -->
          <span class="font-weight-bold text-dark">
            <ng-container
              *ngIf="
                (city.cityName || city.zone || city.nome || city.name || '').toLowerCase() === 'outro';
                else nomeNormal
              ">
              {{ city.stateName || '' }}
            </ng-container>
            <ng-template #nomeNormal>
              {{ city.cityName || city.zone || city.nome || city.name || '-' }}
            </ng-template>
          </span>

          <!-- Hospitais diretos -->
          <div *ngIf="city.hospitals && city.hospitals.length > 0">
            <div class="row mb-3">
              <div class="col-12 col-md-6 col-lg-4 mb-2" *ngFor="let h of city.hospitals | filterName: filtroRede">
                <div class="hospital-card">
                  <i class="fa fa-check-circle text-success mr-2"></i>
                  <span>{{ h.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Zonas -->
          <div *ngIf="city.zones && city.zones.length > 0">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3" *ngFor="let zone of city.zones">
                <div class="zone-card">
                  <div class="zone-header">
                    <i class="fa fa-map-marker-alt text-warning mr-1"></i>
                    <strong>{{ zone.zone }}</strong>
                  </div>
                  <div class="zone-body">
                    <div *ngFor="let h of zone.hospitals | filterName: filtroRede" class="hospital-item">
                      <i class="fa fa-circle text-info mr-2" style="font-size: 8px"></i>
                      {{ h.name }}
                    </div>
                    <div *ngIf="(zone.hospitals | filterName: filtroRede).length === 0" class="text-muted small">
                      Nenhum hospital encontrado
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-3" *ngIf="i < (listaModal.hospitalsInZone | filterZone: filtroRede).length - 1" />
        </div>
      </div>

      <ng-template #noHospitais>
        <div class="empty-state text-center py-4">
          <i class="fa fa-building fa-3x text-muted mb-2"></i>
          <p class="text-muted mb-0">Nenhum hospital cadastrado</p>
        </div>
      </ng-template>
    </div>

    <!-- Laboratórios -->
    <div class="section-laboratory">
      <div class="d-flex align-items-center mb-3">
        <div class="icon-circle bg-success mr-2">
          <i class="fa fa-flask text-white"></i>
        </div>
        <h4 class="mb-0 font-weight-bold text-dark">Laboratórios</h4>
        <span class="badge badge-success ml-2 px-2 round">{{ contarLaboratorios(listaModal) }}</span>
      </div>

      <div *ngIf="listaModal?.laboratories?.length > 0; else noLaboratorios">
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 mb-2"
            *ngFor="let lab of listaModal.laboratories | filterName: filtroRede">
            <div class="laboratory-card">
              <i class="fa fa-flask text-success mr-2"></i>
              {{ lab.name }}
            </div>
          </div>
        </div>
      </div>

      <ng-template #noLaboratorios>
        <div class="empty-state text-center py-4">
          <i class="fa fa-flask fa-3x text-muted mb-2"></i>
          <p class="text-muted mb-0">Nenhum laboratório cadastrado</p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="modal-footer" style="background: #f8f9fc; border-top: 1px solid #e3e6f0">
    <button class="btn btn-outline-info round px-4" (click)="fecharRede()">
      <i class="fa fa-close mr-1"></i>
      Fechar
    </button>
  </div>
</ng-template>
<!-- novo layout inicio -->

<div class="cotacao-wrapper" *ngIf="!deveAbrirModal" id="section-visualizar">
  <!-- Header Cliente -->
  <div class="cotacao-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="client-details">
            <div class="client-item">
              <span class="label">Cliente</span>
              <strong class="value">{{ listaCotacaoVisualizaVM[0]?.cliente }}</strong>
            </div>
            <div class="client-item">
              <span class="label">Corretor</span>
              <strong class="value">{{ listaCotacaoVisualizaVM[0]?.corretor }}</strong>
            </div>
            <div class="client-item">
              <span class="label">E-mail</span>
              <strong class="value">{{ listaCotacaoVisualizaVM[0]?.email }}</strong>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right">
          <div class="logos">
            <img [src]="logoOperadora" class="logo-operadora" *ngIf="logoOperadora" />
            <img src="../../../../../assets/app-assets/images/logo/logo-b-geia.png" class="logo-geia" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Container de Planos -->
  <div class="container-fluid mt-4">
    <div class="row">
      <!-- Grid responsivo: 1 coluna no mobile, 2 no desktop -->
      <div class="col-xl-6 mb-4" *ngFor="let row of listaCotacaoVisualizaVM; let i = index">
        <div class="plan-card">
          <!-- Topo do Card -->
          <div class="plan-card-header">
            <div>
              <div class="plan-badge">GEIA - {{ row.entidade }}</div>
              <h2 class="plan-title">{{ row.produto }}</h2>
              <div class="plan-features">
                <span>{{ row.modalidade }}</span>
                <span *ngIf="!isOdonto()">{{ row.acomodacao }}</span>
                <span>Coparticipação {{ row.coparticipacao | lowercase }}</span>
              </div>
            </div>
            <div class="plan-price">
              <div class="price-value">{{ calcularTotal(row.valores) | currencyBRL }}</div>
              <div class="price-period">por mês</div>
            </div>
          </div>

          <!-- Separador -->
          <div class="plan-divider"></div>

          <!-- Accordion Faixas -->
          <div class="accordion-section">
            <button class="accordion-trigger" (click)="row.isExpandValores = !row.isExpandValores">
              <div class="trigger-left">
                <i class="fa fa-pie-chart"></i>
                <span>Faixas etárias</span>
                <span class="counter">{{ row.valores?.length }} faixas</span>
              </div>
              <i class="fa" [ngClass]="row.isExpandValores ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </button>

            <div class="accordion-content" [class.expanded]="row.isExpandValores">
              <div class="table-responsive">
                <table class="pricing-table">
                  <tbody>
                    <tr *ngFor="let faixa of row.valores">
                      <td class="age-range">{{ faixa.descricaoGrupoPorIdade }}</td>
                      <td class="lives">{{ faixa.totalVida }} vida(s)</td>
                      <td class="price">{{ faixa.valorTotalVidas | currencyBRL }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Accordion Rede -->
          <div class="accordion-section" *ngIf="!isOdonto()">
            <button class="accordion-trigger" (click)="abrirRede(row)">
              <div class="trigger-left">
                <i class="fa fa-building"></i>
                <span>Rede credenciada</span>
                <span class="counter">
                  {{ contarHospitais(row) }} hospitais | {{ contarLaboratorios(row) }} laboratórios
                </span>
              </div>
              <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="cotacao-footer" *ngIf="estaLogado">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-6">
          <button class="link-button" (click)="abrirModalInformacoes()">
            <i class="fa fa-info-circle"></i>
            Informações adicionais
          </button>
        </div>
        <div class="col-md-6 text-right">
          <button class="action-btn" (click)="imprimir()" [disabled]="desabilitarBtn">
            <i class="fa fa-print"></i>
            Imprimir
          </button>
          <button class="action-btn" (click)="enviarCotacaoEmail()" [disabled]="desabilitarBtn">
            <i class="fa fa-envelope"></i>
            E-mail
          </button>
          <button class="action-btn primary" (click)="abrirModalLink()" [disabled]="desabilitarBtn">
            <i class="fa fa-share-alt"></i>
            Compartilhar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- novo layout FIM -->
<!-- <div class="app-content content" *ngIf="!deveAbrirModal" id="section-visualizar">
  <div class="content-wrapper">
    <div class="content-body">
      <div class="content-detached">
        <section class="cotacao-container">
          <div class="header-info">
            <div>
              <p>
                <strong>Cliente:</strong>
                {{ listaCotacaoVisualizaVM[0]?.cliente }}
              </p>
              <p>
                <strong>Corretor:</strong>
                {{ listaCotacaoVisualizaVM[0]?.corretor }}
              </p>
              <p>
                <strong>E-mail:</strong>
                {{ listaCotacaoVisualizaVM[0]?.email }}
              </p>
            </div>

            <div class="logos">
              <img [src]="logoOperadora" class="logo-op" />
              <img src="../../../../../assets/app-assets/images/logo/logo-b-geia.png" class="logo-geia" />
            </div>
          </div>

          <div class="planos-wrapper">
            <div class="plano-card" *ngFor="let row of listaCotacaoVisualizaVM">
              <h4 class="titulo-plano mb-1">GEIA- {{ row.entidade }}</h4>
              <h4 class="titulo-plano">
                {{ row.produto }}
              </h4>
              <div class="title-header mt-1">
                <h5 class="f-badge text-bold-400">Modalidade: {{ row.modalidade }}</h5>
                <h5 *ngIf="!isOdonto()" class="f-badge text-bold-400">Acomodação: {{ row.acomodacao }}</h5>
                <h5 class="f-badge text-bold-400">Copart.: {{ row.coparticipacao }}</h5>
              </div>

              <div class="preco-total mb-0">
                <strong style="font-size: 30px">{{ calcularTotal(row.valores) | currencyBRL }}</strong>
                <span style="font-size: 15px; font-weight: 600">/mês</span>
              </div>
              <hr class="divider my-2" />
              <div class="accordion">
                <div class="acc-item bold" (click)="row.isExpandValores = !row.isExpandValores">
                  <span>Valores por faixa etária</span>
                  <i class="fa" [ngClass]="row.isExpandValores ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>

                <ul *ngIf="row.isExpandValores">
                  <li *ngFor="let faixa of row.valores">
                    <span>{{ faixa.descricaoGrupoPorIdade }} -</span>
                    <span class="ml-1">{{ faixa.totalVida }} vida(s) :</span>
                    <strong>{{ faixa.valorTotalVidas | currencyBRL }}</strong>
                  </li>
                </ul>

                <div class="acc-item bold" *ngIf="!isOdonto()" (click)="abrirRede(row)">
                  <span>Rede(s) Credenciada(s)</span>
                  <i class="fa" [ngClass]="row.isExpandHospitais ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>

                <div *ngIf="row.isExpandHospitais && !isOdonto()">
                  <div class="pl-2 text-left">
                    <strong>Hospitais:</strong>
                    <ng-container *ngFor="let zone of row.hospitalsInZone">
                      <div class="mb-1">
                        <strong>{{ zone.zone }}</strong>
                        <ul class="mt-1 mb-2">
                          <li *ngFor="let hospital of zone.hospitals">
                            {{ hospital.name }}
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </div>

                  <div class="pl-2 text-left mt-2">
                    <strong>Laboratórios:</strong>
                    <ul class="mt-1">
                      <li *ngFor="let lab of row.laboratories">
                        {{ lab.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="row footer container" *ngIf="!deveAbrirModal">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-12">
        <h5 class="blog-title mt-2">
          <span class="desc-card-doctor bold-azul-geia f-600 cursor-pointer" (click)="abrirModalInformacoes()">
            + Informações
          </span>
        </h5>
      </div>
      <div *ngIf="estaLogado" class="form-actions col-12" style="text-align: right">
        <button
          [class.no-drop]="desabilitarBtn"
          [disabled]="desabilitarBtn"
          (click)="imprimir()"
          type="button"
          class="btn btn-round btn-geia-info btn-outline-success cursor-pointer btn-min-width box-shadow-4 mr-1 mb-1 no-print"
          style="margin-top: -48px">
          <i class="ft-printer"></i>
          Imprimir
        </button>
        <button
          [class.no-drop]="desabilitarBtn"
          [disabled]="desabilitarBtn"
          (click)="enviarCotacaoEmail()"
          type="button"
          class="btn btn-round btn-geia-info btn-outline-success cursor-pointer btn-min-width box-shadow-4 mr-1 mb-1 no-print"
          style="margin-top: -48px">
          <i class="ft-mail"></i>
          Enviar/E-mail
        </button>

        <button
          [class.no-drop]="desabilitarBtn"
          [disabled]="desabilitarBtn"
          (click)="abrirModalLink()"
          type="button"
          class="btn btn-round btn-geia-info btn-outline-success cursor-pointer btn-min-width box-shadow-4 mr-1 mb-1 no-print"
          style="margin-top: -48px">
          <i class="fa fa-link"></i>
          Compartilhar link
        </button>
      </div>
    </div>
  </div>
</div> -->

<ng-template #modalMaisInformacoes>
  <div class="modal-header bg-info">
    <h4 class="modal-title white" style="font-weight: bold !important">+ Informações</h4>
    <button type="button" class="close" (click)="fecharModalInformacoes()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-cotacao-informacoes [tipoProduto]="tipoProduto"></app-cotacao-informacoes>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-min-width mr-1 mb-1"
      (click)="fecharModalInformacoes()">
      Fechar
    </button>
  </div>
</ng-template>

<div class="modal fade" id="modal-duvidas" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
  <ng-template #modalAuthDataNascimento let-modal>
    <div class="modal-header bg bg-info">
      <h5 class="modal-title white" id="exampleModalLongTitle">Validação data de nascimento.</h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 text-center mt-2 mb-2">
          <h3 class="bold text-center mt-2 mb-2">
            Informe a data de nascimento do titular:
            <span class="mt-2" style="color: black">
              <i class="fa fa-user"></i>
              {{ dados?.prices[0]?.holderQuote?.name }}
              <!-- {{ dados?.prices[0]?.holderQuote?.dateOfBirth }} -->
            </span>
          </h3>
          <div class="col-md-8 col-sm-12 mb-1 mx-auto">
            <div class="input-group justify-content-center">
              <input
                [(ngModel)]="dataNascimento"
                #datepicker="bsDatepicker"
                bsDatepicker
                name="birthDate"
                maxlength="10"
                type="text"
                placeholder="dd/mm/aaaa"
                class="form-control bold-azul-geia bold round bg-white text-center"
                id="aniversario"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [bsConfig]="bsConfig" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary botao-calendario" type="button" (click)="datepicker.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button
          [disabled]="!dataNascimento"
          type="button"
          class="btn btn-success round box-shadow-4 mr-2"
          (click)="confirmarAniversario()">
          <i class="ft-thumbs-up"></i>
          Confirmar
        </button>
        <button type="button" class="btn btn-warning round box-shadow-4" (click)="decline()">
          <i class="ft-thumbs-down"></i>
          Cancelar
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #modalLink let-modal>
    <div class="modal-header bg bg-info">
      <h5 class="modal-title white">Compartilhar Link</h5>
      <button type="button" class="close" (click)="fecharModalLink()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="input-group mb-3">
        <input type="text" class="round form-control" [value]="urlAtual" #linkInput readonly />
        <div class="input-group-append">
          <button class="btn btn-info" type="button" (click)="copiarLink(linkInput)">
            <i class="fa fa-copy"></i>
            Copiar
          </button>
        </div>
      </div>
      <div *ngIf="linkCopiado" class="text-center alert-success mt-2 mb-0 py-1">Link copiado com sucesso!</div>
    </div>
  </ng-template>
</div>
